import createRoute   from '@widesk-ui/tools/createRoute';
import SitePageModel from '@models/website/SitePageModel';

const route = createRoute.splitView(
	'/website_entertainments/:websiteEntertainmentId/site_pages',
	'website',
	'SitePageSplitView',
	SitePageModel.localize('plural'),
);
export default route;
